import { Link, useLocation } from "react-router-dom";
import PredictTarget from "@/pages/PredictTarget";
import useSeo from "@/hooks/useSeo";
import PageSeoNote from "@/components/PageSeoNote";
import { findKeywordConfig } from "@/constants/keywordLandings";

export default function TargetNumber() {
  const { pathname } = useLocation();
  const kw = findKeywordConfig(pathname);
  useSeo({
    title: kw?.title || "Morning Teer Target Number Today | Shillong Morning Teer",
    description:
      kw?.description ||
      "Morning Teer Target Number for today — data-driven picks derived from the most frequent house and ending digits of recent Shillong Morning Teer results.",
    path: pathname,
    breadcrumbs: [
      { name: "Home", path: "/" },
      { name: "Target Number", path: pathname },
    ],
  });

  return (
    <>
      {/* SEO H1 for this page (visually styled) */}
      <div className="max-w-xl mx-auto w-full px-4 pt-6">
        <h1 className="font-heading font-black text-slate-900 text-3xl sm:text-4xl tracking-tight">
          {kw?.h1 || "Morning Teer Target Number Today"}
        </h1>
        <p className="text-sm text-slate-500 mt-1">
          Statistical picks derived from recent Shillong Morning Teer FR and SR results. These
          suggestions are a study reference and are not guaranteed.
        </p>
      </div>

      {/* Existing prediction UI */}
      <PredictTarget />

      <div className="max-w-xl mx-auto w-full px-4 pb-10 mt-4 text-sm text-slate-600 leading-relaxed">
        <p>
          The Target Number is calculated from the most frequent House digit and the most frequent
          Ending digit across the last several draws. It gives you a shortlist of two-digit
          combinations that appeared most often historically — nothing more, nothing less. For
          more context, view the{" "}
          <Link to="/common-number" className="text-sky-700 font-semibold underline">
            Common Number
          </Link>
          , explore{" "}
          <Link to="/previous-results" className="text-sky-700 font-semibold underline">
            Previous Results
          </Link>
          , or browse the{" "}
          <Link to="/result-chart" className="text-sky-700 font-semibold underline">
            Result Chart
          </Link>
          .
        </p>
      </div>
      <PageSeoNote topic="target-number" />
    </>
  );
}
